export default __webpack_public_path__ + "static/media/ic_skip_next_48px.4cd36da6.svg";